import React, { Component } from "react";
import LoaderModal from "../../../../components/modal/LoaderModal";
import utilManagement from "../../../../apis/utilManagement";
// import jsonFile from "../dinas/report_ensa_dinas.json";
import { Bubble } from "react-chartjs-2";
import {
    ReportHeader,
    CardProfile,
    EnsaCard,
    EnsaCard2,
    EnsaCardPageBreak,
    ChartLabel,
    LabelChartProgresLiterasi,
    LabelChartKeteranganProgLit,
    LabelResumeKomparasi,
    TableLiterasiSiswaPotensi,
    ChartP3,
    TableKomparasiSekolah,
} from "../index";
import {
    GaugeDoughnut,
    ChartLineProgresLiterasi,
    PieChart,
    ChartLineKesenjanganLiterasi,
    ChartLineStatusSosialLiterasi,
    MapChart,
    PackedChart,
    PackedChartDinas,
    DumbbellPlotDesilV2,
    DumbbellPlot,
    ScatterChart,
    ChartBar,
    TreemapChartDinas
} from "../../../../components/Global";
import EnsaConstant from "../EnsaConstant";
import { CONFIG_UTIL } from "../../../../config";

class ReportSiswa extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            dataDinas: {
                kokab: '',
                namaDinas: '',
                jumsis: '',
                tanggal: ''
            },
            dataMaps: {
                daerah: [],
                nasional: []
            },
            dataLiterasiIndeks: {
                mapels: []
            },
            dataLiterasiAllIdx: {},
            easypiechartId: ['easypiechart-blue', 'easypiechart-red', 'easypiechart-green'],
            prosentasiCapaianKompetensi: [],
            dataProgresLiterasi: {
                progresIndex: {
                    skor: [],
                    prosentase: 0,
                    rangeTahun: [],
                    dataKeterangan: []
                },
                progresCapaian: {
                    skor: [],
                    prosentase: 0,
                    rangeTahun: [],
                    dataKeterangan: []
                }
            },
            dataLiterasiLevel: {
                membaca: [],
                matematika: [],
                sains: []
            },
            dataLiterasiLevel2: [],
            dataKomparasiLiterasi: {
                listSekolah: [],
                listResume: [],
                value: [
                    {
                        key: '',
                        value: []
                    }
                ],
                listDescription: [
                    {key: "", value: 0},
                    {key: "", value: 0},
                    {key: "", value: 0},
                    {key: "", value: 0}
                ]
            },
            // dataResumeKomparasi: [],
            dataSekolahPotensiDarurat: {
                potensi: [],
                darurat: []
            },
            dataRaportSk: {
                karakterDimensi: [],
                prosentaseHasilSK: [],
                temaProjek: [],
                posisiSekolah: [],
                komparasiGender: {
                    kritis: {
                        listData: []
                    },
                    kreatif: {
                        listData: []
                    },
                    goyong: {
                        listData: []
                    },
                    mandiri: {
                        listData: []
                    },
                    kebhinekaan: {
                        listData: []
                    },
                    beriman: {
                        listData: []
                    }
                },
                komparasiAntarSekolah: {
                    resume: [],
                    data: {
                        kritis: {
                            listData: []
                        },
                        kreatif: {
                            listData: []
                        },
                        goyong: {
                            listData: []
                        },
                        mandiri: {
                            listData: []
                        },
                        berkebhinekaan: {
                            listData: []
                        },
                        beriman: {
                            listData: []
                        }
                    }
                },
                progres: {
                    skor: [],
                    prosentase: 0,
                    rangeTahun: [],
                    listData: []
                }
            },
            compareSkGoyong: [],
            compareSkMandiri: [],
            compareSkKritis: [],
            compareSkBeriman: [],
            compareSkBerkebinekaan: [],
            compareSkKreatif: [],
            performaDesil: [],
            dataReportSlb: {
                kualitasPembelajaran: {
                    value: []
                },
                iklimKeamananSekolah: {
                    value: []
                },
                iklimKebinekaan: {
                    value: []
                },
                posisiSekolah: [],
                kesenjanganGender: [],
                kesenjanganStatus: [],
                progres: {
                    listData: [],
                    rangeTahun: []
                },
                dataBulat: [],
                compareSekolah: {
                    bhineka: [],
                    keamananSekolah: [],
                    pembelajaran: []
                }
            },
            dataKesenjanganLiterasi: {
                title: [],
                literasiGender: {},
                literasiSosialEkonomi: {}
            },
            performaPersentils: [
                {
                    key: '',
                    value: []
                }
            ],
            rerataSekolah: []
        };
    }

    async componentDidMount() {
        this.setState({
            isFetching: true,
        });
        this.getReport();
    }


    async getReport() {
        const path = this.props.history.location.pathname.split("/");
        const response = await utilManagement.post(CONFIG_UTIL.REPORT_ENSA_DINAS, {
            "idProfilCbt": path[2],
            "idDinas": path[3]
        })
        if (response) {
            const res = response.data.data;
            this.setState({
                isFetching: false,
                dataDinas: res.dataDinas,
                dataMaps: res.maps,
                dataLiterasiIndeks: res.literasiIndeks,
                dataLiterasiAllIdx: res.literasiIndeks.overall[0],
                prosentasiCapaianKompetensi: res.prosentasiCapaianKompetensi,
                dataLiterasiCapaian: res.listLiterasiCapaian,
                dataProgresLiterasi: res.progresLiterasi,
                dataLiterasiLevel2: res.levelLiterasi,
                dataKesenjanganLiterasi: res.kesenjanganLiterasi,
                dataKomparasiLiterasi: res.komparasiLiterasi,
                dataSekolahPotensiDarurat: res.siswaPotensiDarurat,
                dataRaportSk: res.raportSk,
                compareSkGoyong: res.raportSk.comparationGender.goyong,
                compareSkMandiri: res.raportSk.comparationGender.mandiri,
                compareSkKritis: res.raportSk.comparationGender.kritis,
                compareSkBeriman: res.raportSk.comparationGender.beriman,
                compareSkBerkebinekaan: res.raportSk.comparationGender.berkebhinekaan,
                compareSkKreatif: res.raportSk.comparationGender.kreatif,
                performaDesil: res.performaDensil,
                dataReportSlb: res.raportSLB,
                performaPersentils: res.performaPersentils,
                rerataSekolah: res.rerataSekolah,
            });
        } else {
            this.setState({
                isFetching: false,
                error: true,
                alertShow: true,
                // resMessage: response.data.errorSchema.errorMessage,
            });
        }
        (function () {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "/assets/js/easypiechart-data.js";
            document.getElementsByTagName("head")[0].appendChild(script);
        })();
    }

    getPersentilByKey(key) {
        let data = []
        for (let i in this.state.performaPersentils) {
            const sentil = this.state.performaPersentils[i]
            if (sentil.key == key) {
                data = sentil.value
                break
            }
        }
        return data
    }


    render() {
        require("./ReportDinas.css");
        const { isFetching,
            dataDinas,
            dataMaps,
            dataLiterasiIndeks,
            dataLiterasiAllIdx,
            prosentasiCapaianKompetensi,
            easypiechartId,
            dataKesenjanganLiterasi,
            dataProgresLiterasi,
            dataLiterasiLevel2,
            dataKomparasiLiterasi,
            dataSekolahPotensiDarurat,
            dataRaportSk,
            compareSkGoyong,
            compareSkMandiri,
            compareSkKritis,
            compareSkBeriman,
            compareSkBerkebinekaan,
            compareSkKreatif,
            dataReportSlb,
            rerataSekolah,
            performaDesil,
        } =
            this.state;
        return (
            <div>
                <LoaderModal isFetching={isFetching} />
                {/* page 1 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Kota Eduprime'} page={1} />

                    <div className="cardLine">
                        <div className="flex-pln-profile">
                            <CardProfile
                                label={"Kota/Kab"}
                                value={dataDinas.namaWilayah != null ? dataDinas.namaWilayah : ''}
                                iconImage={"/assets/image/icon-sekolah.svg"}
                            />
                            <CardProfile
                                label={"Dinas"}
                                value={dataDinas.namaDinas != null ? dataDinas.namaDinas : ''}
                                iconImage={"/assets/image/icon-kelas.svg"}
                            />
                            <CardProfile
                                label={"Jumlah Siswa"}
                                value={dataDinas.jumsis != null ? dataDinas.jumsis : ''}
                                iconImage={"/assets/image/jumlah-siswa.svg"}
                            />
                            <CardProfile
                                label={"Tgl Asesmen"}
                                value={dataDinas.jadwalMulai != null ? dataDinas.jadwalMulai : ''}
                                iconImage={"/assets/image/mdi_date.svg"}
                            />
                        </div>
                    </div>

                    <EnsaCard title="Peta Peserta ENSA">
                        <MapChart id="geoChartDns1" dataset={dataMaps.nasional}></MapChart>
                    </EnsaCard>
                    <EnsaCard title="Peta Peserta ENSA Kota Eduprime">
                        <MapChart id="geoChartDns2" dataset={dataMaps.daerah}></MapChart>
                    </EnsaCard>
                </div>

                {/* page 2 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Kota Eduprime'} page={2} />

                    <div className="cardLine">
                        <div className="point-title">Rapor Performa Literasi</div>
                    </div>

                    <EnsaCard title="A. Performa Literasi berdasarkan Indeks">
                        <div className="chart-container">
                            <GaugeDoughnut
                                className="chart-overall-index"
                                id="gaugeNeedle"
                                valueChart={[dataLiterasiAllIdx.value, 3 - dataLiterasiAllIdx.value]}
                                chartColor={["#015E56", "#C9FCD1"]}
                                skor={dataLiterasiAllIdx.value}
                                chartLabel="Overall Index"
                                description="Mencapai Kompetensi Minimum"
                            />
                            <div className="chart-literasi">

                                {dataLiterasiIndeks.mapels.map((item, i) => (
                                    <div key={i}>
                                        <GaugeDoughnut
                                            className="chart-gauge"
                                            id="gaugeNeedle"
                                            skor={item.value}
                                            valueChart={[item.value, 3 - item.value]}
                                            chartColor={[item.keterangan == 'atas' ? "#03C46B" : '#FF3838', "#E8E9E7"]}
                                        >
                                            <ChartLabel
                                                title={item.key}
                                                desc={item.description}
                                                type={item.key}
                                            />
                                        </GaugeDoughnut>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </EnsaCard>
                    <EnsaCard title="B. Performa Literasi berdasarkan Capaian">
                        <div className="flex-pnl-around">
                            {prosentasiCapaianKompetensi.map((item, index) => (
                                <div style={{ textAlign: 'center' }} key={index}>
                                    <div style={{ fontSize: '18px', textAlign: 'center' }}>{item.key}</div>
                                    <div className="easypiechart chart" id={easypiechartId[index]} data-percent={item.scoreIndexCurrent}>
                                        <div className="label_persentase_potensi_chart" style={{ paddingTop: '68px' }}>
                                            <span className="persentase_potensi">{item.scoreIndexCurrent}%</span>
                                            <br />
                                        </div>
                                    </div>
                                    <ChartLabel
                                        skor={item.scoreIndexCurrent}
                                        desc={item.description}
                                        type={item.status}
                                    />
                                </div>
                            ))}
                        </div>
                    </EnsaCard>
                </div>
                {/* page 3 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={3} />
                    <EnsaCard title="C. Progres Performa Literasi">
                        <div className="flex-pnl-between">
                            <div className="pnl-chartLine" style={{ borderRight: '2px solid #015E56' }}>
                                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                    <span className="tit-card-perfomlit">1. Progres Performa Literasi-Indeks</span>
                                </div>
                                <LabelChartProgresLiterasi title={'Indeks'} skor={dataProgresLiterasi.progresIndex.skor} prosentase={dataProgresLiterasi.progresIndex.prosentase} />
                                <ChartLineProgresLiterasi dataProgres={dataProgresLiterasi.progresIndex.dataKeterangan} ranges={dataProgresLiterasi.progresIndex.rangeTahun} />
                                <LabelChartKeteranganProgLit listData={dataProgresLiterasi.progresIndex.dataKeterangan} sekolah={dataDinas.namaDinas} />
                            </div>
                            <div className="pnl-chartLine">
                                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                    <span className="tit-card-perfomlit">2. Progres Performa Literasi-Capaian</span>
                                </div>
                                <LabelChartProgresLiterasi title={'Indeks'} skor={dataProgresLiterasi.progresCapaian.skor} prosentase={dataProgresLiterasi.progresCapaian.prosentase} />
                                <ChartLineProgresLiterasi dataProgres={dataProgresLiterasi.progresCapaian.dataKeterangan} ranges={dataProgresLiterasi.progresCapaian.rangeTahun} />
                                <LabelChartKeteranganProgLit listData={dataProgresLiterasi.progresCapaian.dataKeterangan} sekolah={dataDinas.namaDinas} />
                            </div>
                        </div>
                    </EnsaCard>
                    <EnsaCard title="D. Performa Literasi berdasarkan Level">
                        <div className="flex-pnl-around">
                            {dataLiterasiLevel2.map((item, i) => (
                                <div style={{ textAlign: 'center' }} key={i}>
                                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
                                        <div className="chart-label" style={{
                                            backgroundColor: item.key == 'LITERASI MEMBACA' ? EnsaConstant.COLOR.GREEN
                                                : item.key == 'LITERASI SAINS' ? EnsaConstant.COLOR.YELOW : EnsaConstant.COLOR.BLUE
                                        }}>{item.key}</div>
                                    </div>
                                    <PieChart id={"pieChartLvDin" + i} dataSkor={item.value} colors={item.key == 'LITERASI MEMBACA' ? EnsaConstant.COLOR.CHART_PIE_MEMBACA
                                        : item.key == 'LITERASI SAINS' ? EnsaConstant.COLOR.CHART_PIE_SAINS : EnsaConstant.COLOR.CHART_PIE_MATEMATIKA} />
                                </div>
                            ))}
                        </div>
                    </EnsaCard>
                </div>
                {/* page 4*/}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={4} />
                    <EnsaCard title="E. Kesenjangan Performa Literasi">
                        <div className="flex-pnl-between">
                            <div style={{ width: '40%' }}>
                                <div className="label-value-profil" style={{ fontSize: '16px', textAlign: 'center', marginBottom: '15px' }}>1. Kesenjangan Performa Literasi-Gender</div>
                                <ChartLineKesenjanganLiterasi dataProgres={dataKesenjanganLiterasi.literasiGender} listTitle={dataKesenjanganLiterasi.title} />
                            </div>
                            <div style={{ width: '60%' }}>
                                <div className="label-value-profil" style={{ fontSize: '16px', textAlign: 'center', marginBottom: '15px' }}>2. Kesenjangan Performa Literasi-Status Sosial Ekoomi</div>
                                <ChartLineStatusSosialLiterasi dataProgres={dataKesenjanganLiterasi.literasiSosialEkonomi} listTitle={dataKesenjanganLiterasi.title} />
                            </div>
                        </div>
                    </EnsaCard>
                    <EnsaCard title="F. Komparasi Performa Literasi">
                        <div style={{ width: '100%', display: 'flex', gap: '20px' }}>
                            {dataKomparasiLiterasi.value.map((item, i) => (
                                <div style={{ width: '33%' }} key={i}>
                                    <span style={{ fontSize: '20px' }}>{item.key}</span>
                                    <PackedChartDinas id={'packedChart-' + i} dataset={item.value} showLabel={false} size={20} fontSize={14} reqHeight={300}></PackedChartDinas>
                                </div>
                            ))}
                        </div>
                    </EnsaCard>
                </div>
                {/* page 5 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={5} />
                    <EnsaCardPageBreak isBreak="always">
                        <div style={{ display: 'flex', flexWrap: 'wrap', rowGap: '10px', columnGap: '10px' }}>
                            {dataKomparasiLiterasi.listSekolah.map((item, i) => (
                                <div style={{ display: 'flex', flex: '1 1 200px', alignItems: 'center', gap: '10px' }} key={i}>
                                    <div style={{ width: '20px', height: '10px', borderRadius: '10px', backgroundColor: item.color }}></div>
                                    <div className="label-profile-name">{item.key}</div>
                                </div>
                            ))}
                        </div>
                    </EnsaCardPageBreak>
                    <EnsaCardPageBreak >
                        <div style={{ width: '100%', display: 'flex', gap: '20px' }}>
                            <div style={{ width: '60%', borderRight: '2px solid #015E56', paddingRight: '20px' }}>
                                <table className="table table-custom" id="rekap">
                                    <thead>
                                        <tr>
                                            <th className="th-title v-align-left" rowSpan="2" scope="col">
                                                Sekolah
                                            </th>
                                            <th className="th-title v-align-center" rowSpan="2" scope="col">
                                                Literasi Matematika
                                            </th>
                                            <th className="th-title v-align-center" rowSpan="2" scope="col">
                                                Literasi Membaca
                                            </th>
                                            <th className="th-title v-align-center" rowSpan="2" scope="col">
                                                Literasi Sains
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dataKomparasiLiterasi.listResume.map((item, i) =>
                                            <tr key={i}>
                                                <td align="left">{item.namaSekolah}</td>
                                                <td align="center">{item.literasiMatematika}</td>
                                                <td align="center">{item.literasiMembaca}</td>
                                                <td align="center">{item.literasiSains}</td>
                                            </tr>
                                        )}

                                    </tbody>
                                </table>
                            </div>
                            <div style={{ width: '40%' }}>
                                <LabelResumeKomparasi mapel="matematika" sekolah1={dataKomparasiLiterasi.listDescription[0].key1} sekolah2={dataKomparasiLiterasi.listDescription[0].key2} skor1={dataKomparasiLiterasi.listDescription[0].value1} skor2={dataKomparasiLiterasi.listDescription[0].value2} rata={false} />
                                <LabelResumeKomparasi mapel="membaca" sekolah1={dataKomparasiLiterasi.listDescription[1].key1} sekolah2={dataKomparasiLiterasi.listDescription[1].key2} skor1={dataKomparasiLiterasi.listDescription[1].value1} skor2={dataKomparasiLiterasi.listDescription[1].value2} rata={false} />
                                <LabelResumeKomparasi mapel="sains" sekolah1={dataKomparasiLiterasi.listDescription[2].key1} sekolah2={dataKomparasiLiterasi.listDescription[2].key2} skor1={dataKomparasiLiterasi.listDescription[2].value1} skor2={dataKomparasiLiterasi.listDescription[2].value2} rata={false} />
                                <LabelResumeKomparasi sekolah1={dataKomparasiLiterasi.listDescription[3].key1} sekolah2={dataKomparasiLiterasi.listDescription[3].key2} skor1={dataKomparasiLiterasi.listDescription[3].value1} skor2={dataKomparasiLiterasi.listDescription[3].value2} rata={true} />
                            </div>
                        </div>
                    </EnsaCardPageBreak>
                </div>
                {/* page 6 */}
                <div className="report-page" style={{ pageBreakBefore: 'always' }}>
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={6} />
                    <div className="cardLine">
                        <div className="point-title">G. Performa dalam Desil Nasional</div>
                    </div>
                    {performaDesil.map((item, i) =>
                        <EnsaCard title={`G.${i + 1}. ${item.key.replace("_", " ").toUpperCase()} dalam Desil Nasional`} key={i}>
                            <DumbbellPlotDesilV2 id={'plotPerformMemNas' + i} dataset={item.value}></DumbbellPlotDesilV2>
                        </EnsaCard>
                    )}
                </div>
                {/* page 7 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={7} />
                    <div className="cardLine">
                        <div className="point-title">H. Performa dalam Persentil 20, 50, dan 90</div>
                    </div>
                    <EnsaCard title="H.1 Performa Literasi Membaca dalam Persentil 20, 50, dan 90">
                        <DumbbellPlot id="dumPltPerfMem" dataset={this.getPersentilByKey('literasi_membaca')}></DumbbellPlot>
                    </EnsaCard>
                </div>
                {/* page 8 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={8} />
                    <EnsaCard2 title="H.2 Performa Literasi Matematika dalam Persentil 20, 50, dan 90" width={100} marginBottom={20}>
                        <DumbbellPlot id="dumPltPerfMat" dataset={this.getPersentilByKey('literasi_matematika')}></DumbbellPlot>
                    </EnsaCard2>
                </div>
                {/* page 9 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={9} />
                    <EnsaCard2 title="H.3 Performa Literasi Sains dalam Persentil 20, 50, dan 90" width={100} marginBottom={20}>
                        <DumbbellPlot id="dumPltPerfSai" dataset={this.getPersentilByKey('literasi_sains')}></DumbbellPlot>
                    </EnsaCard2>
                </div>
                {/* page 10 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={10} />
                    <div className="cardLine">
                        <div className="point-title">I. Rata-Rata Sekolah-Wilayah-Nasional</div>
                    </div>
                    <EnsaCard2 title="I.1. Rata-Rata Sekolah-Wilayah-Nasional Literasi Membaca" width={100} marginBottom={20}>
                        {rerataSekolah.literasi_membaca ? <ScatterChart id="scatterPerfMem" dataSet={rerataSekolah.literasi_membaca}></ScatterChart> : null}
                    </EnsaCard2>
                </div>
                {/* page 11 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={11} />
                    <EnsaCard2 title="I.2. Rata-Rata Sekolah-Wilayah-Nasional Literasi Matematika" width={100} marginBottom={20}>
                        {rerataSekolah.literasi_matematika ? <ScatterChart id="scatterPerfMat" dataSet={rerataSekolah.literasi_matematika}></ScatterChart> : null}
                    </EnsaCard2>
                </div>
                {/* page 12 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={12} />
                    <EnsaCard2 title="I.3. Rata-Rata Sekolah-Wilayah-Nasional Literasi Sains" width={100} marginBottom={20}>
                        {rerataSekolah.literasi_sains ? <ScatterChart id="scatterPerfSains" dataSet={rerataSekolah.literasi_sains}></ScatterChart> : null}
                    </EnsaCard2>
                </div>'
                {/* page 13 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={13} />
                    <div className="cardLine">
                        <div className="point-title">Siswa Potensi dan Darurat</div>
                    </div>
                    <EnsaCardPageBreak title="A. Sekolah Potensial Literasi">
                        <TableLiterasiSiswaPotensi dataLiterasi={dataSekolahPotensiDarurat} isPotensi={true} hasSekolah={false} />
                    </EnsaCardPageBreak>
                    <EnsaCardPageBreak title="B. Sekolah Darurat Literasi">
                        <TableLiterasiSiswaPotensi dataLiterasi={dataSekolahPotensiDarurat} isPotensi={false} hasSekolah={false} />
                    </EnsaCardPageBreak>
                </div>
                {/* page 14 */}
                <div className="report-page" style={{ pageBreakBefore: 'always' }}>
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={14} />
                    <div className="cardLine">
                        <div className="point-title" style={{ marginBottom: '20px' }}>Rapor Survei Karakter</div>
                        <div className="flex-pnl-between" style={{ gap: '20px' }}>
                            <EnsaCard2 title="A. Persentase Hasil Survei Karakter" width={40}>
                                <ChartBar dataLiterasi={dataRaportSk.prosentaseHasilSK} />
                            </EnsaCard2>
                            <EnsaCard2 title="B. Karakter berdasarkan Dimensi P3" width={60}>
                                <ChartP3 dataLiterasi={dataRaportSk.karakterDimensi} className={'pnl-p3'} />
                            </EnsaCard2>
                        </div>
                        <div className="flex-pnl-between" style={{ gap: '20px', marginBottom: '0px' }}>
                            <EnsaCard2 title="C. Progres Survei Karakter" width={40}>
                                <ChartLineProgresLiterasi dataProgres={dataRaportSk.progres.listData} ranges={dataRaportSk.progres.rangeTahun} height={300} />
                                <div style={{ display: 'flex', flexWrap: 'wrap', rowGap: '10px', columnGap: '10px' }}>
                                    {dataRaportSk.progres.listData.map((item, i) => (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }} key={i}>
                                            <div style={{ width: '20px', height: '10px', borderRadius: '10px', backgroundColor: item.color }}></div>
                                            <div className="label-profile-name">{item.kategori}</div>
                                        </div>
                                    ))}
                                </div>
                            </EnsaCard2>
                        </div>
                    </div>
                </div>
                {/* page 15 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={15} />
                    {dataRaportSk.komparasiAntarSekolah != null ?
                        <EnsaCardPageBreak title="D. Komparasi Antar Sekolah">
                            <div className="pnl-packChart">
                                <div>
                                    <span style={{ fontSize: '20px' }}>Kritis</span>
                                    <PackedChart id={'packedChartDns-kritis'} dataset={dataRaportSk.komparasiAntarSekolah.data.kritis.listData} showLabel={true} size={15} fontSize={10}></PackedChart>
                                </div>
                                <div>
                                    <span style={{ fontSize: '20px' }}>Kreatif</span>
                                    <PackedChart id={'packedChartDns-kreatif'} dataset={dataRaportSk.komparasiAntarSekolah.data.kreatif.listData} showLabel={true} size={15} fontSize={10}></PackedChart>
                                </div>
                                <div>
                                    <span style={{ fontSize: '20px' }}>Gotong Royong</span>
                                    <PackedChart id={'packedChartDns-goyong'} dataset={dataRaportSk.komparasiAntarSekolah.data.goyong.listData} showLabel={true} size={15} fontSize={10}></PackedChart>
                                </div>
                                <div>
                                    <span style={{ fontSize: '20px' }}>Mandiri</span>
                                    <PackedChart id={'packedChartDns-mandiri'} dataset={dataRaportSk.komparasiAntarSekolah.data.mandiri.listData} showLabel={true} size={15} fontSize={10}></PackedChart>
                                </div>
                                <div>
                                    <span style={{ fontSize: '20px' }}>Berkebhinekaan</span>
                                    <PackedChart id={'packedChartDns-berkebhinekaan'} dataset={dataRaportSk.komparasiAntarSekolah.data.berkebhinekaan.listData} showLabel={true} size={15} fontSize={10}></PackedChart>
                                </div>
                                <div>
                                    <span style={{ fontSize: '20px' }}>Beriman</span>
                                    <PackedChart id={'packedChartDns-beriman'} dataset={dataRaportSk.komparasiAntarSekolah.data.beriman.listData} showLabel={true} size={15} fontSize={10}></PackedChart>
                                </div>
                            </div>
                            <div style={{ width: '100%' }}>
                                <TableKomparasiSekolah listResume={dataRaportSk.komparasiAntarSekolah.resume} />
                            </div>
                        </EnsaCardPageBreak> : null}
                </div>
                {/* page 16 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={17} />
                    <div className="cardLine">
                        <div className="flex-pnl-between" style={{ gap: '20px', pageBreakAfter: 'always' }}>
                            {
                                compareSkGoyong != null ?
                                    <EnsaCard2 title="D.1. Komparasi Antar Sekolah-Gender - Gotong Royong" width={100}>
                                        <div style={{ width: '100%' }}>
                                            <TreemapChartDinas id={'sk-komGender-goyong'} dataset={compareSkGoyong}></TreemapChartDinas>
                                        </div>
                                    </EnsaCard2> : null
                            }
                        </div>
                    </div>
                </div>
                <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={18} />
                <div className="cardLine">
                    <div className="flex-pnl-between" style={{ gap: '20px', pageBreakAfter: 'always' }}>
                        {
                            compareSkMandiri != null ?
                                <EnsaCard2 title="D.2. Komparasi Antar Sekolah-Gender - Mandiri" width={100}>
                                    <div style={{ width: '100%' }}>
                                        <TreemapChartDinas id={'sk-komGender-mandiri'} dataset={compareSkMandiri}></TreemapChartDinas>
                                    </div>
                                </EnsaCard2> : null
                        }
                    </div>
                </div>
                <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={19} />
                <div className="cardLine">
                    <div className="flex-pnl-between" style={{ gap: '20px', pageBreakAfter: 'always' }}>
                        {
                            compareSkKritis != null ?
                                <EnsaCard2 title="D.3. Komparasi Antar Sekolah-Gender - Kritis" width={100}>
                                    <div style={{ width: '100%' }}>
                                        <TreemapChartDinas id={'sk-komGender-kritis'} dataset={compareSkKritis}></TreemapChartDinas>
                                    </div>
                                </EnsaCard2> : null
                        }
                    </div>
                </div>
                <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={20} />
                <div className="cardLine">
                    <div className="flex-pnl-between" style={{ gap: '20px', pageBreakAfter: 'always' }}>
                        {
                            compareSkBeriman != null ?
                                <EnsaCard2 title="D.4. Komparasi Antar Sekolah-Gender - Beriman" width={100}>
                                    <div style={{ width: '100%' }}>
                                        <TreemapChartDinas id={'sk-komGender-beriman'} dataset={compareSkBeriman}></TreemapChartDinas>
                                    </div>
                                </EnsaCard2> : null
                        }
                    </div>
                </div>
                <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={21} />
                <div className="cardLine">
                    <div className="flex-pnl-between" style={{ gap: '20px', pageBreakAfter: 'always' }}>
                        {
                            compareSkBerkebinekaan != null ?
                                <EnsaCard2 title="D.5. Komparasi Antar Sekolah-Gender - Berkebinekaan" width={100}>
                                    <div style={{ width: '100%' }}>
                                        <TreemapChartDinas id={'sk-komGender-krberkebinekaan'} dataset={compareSkBerkebinekaan}></TreemapChartDinas>
                                    </div>
                                </EnsaCard2> : null
                        }
                    </div>
                </div>
                <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Rapor Pendidikan Siswa'} page={22} />
                <div className="cardLine">
                    <div className="flex-pnl-between" style={{ gap: '20px', pageBreakAfter: 'always' }}>
                        {
                            compareSkKreatif != null ?
                                <EnsaCard2 title="D.6. Komparasi Antar Sekolah-Gender - Kreatif" width={100}>
                                    <div style={{ width: '100%' }}>
                                        <TreemapChartDinas id={'sk-komGender-kreatif'} dataset={compareSkKreatif}></TreemapChartDinas>
                                    </div>
                                </EnsaCard2> : null
                        }
                    </div>
                </div>
                {/* page 17 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Raport Pendidikan Sekolah'} page={23} />
                    <div className="cardLine">
                        <div className="point-title">Rapor Survei Lingkungan Belajar</div>
                    </div>
                    <EnsaCard title="A. Kualitas Pembelajaran">
                        <div className="flex-pnl-between">
                            <div style={{ width: '25%' }}>
                                <GaugeDoughnut
                                    className="chart-gauge2"
                                    id="gaugeNeedle"
                                    skor={dataReportSlb.kualitasPembelajaran.skor}
                                    valueChart={[dataReportSlb.kualitasPembelajaran.skor, 3 - dataReportSlb.kualitasPembelajaran.skor]}
                                    chartColor={[dataReportSlb.kualitasPembelajaran.color]}
                                >
                                    <div className="point-label">{dataReportSlb.kualitasPembelajaran.key}</div>
                                </GaugeDoughnut>
                            </div>
                            <div style={{ width: '75%', display: 'flex', alignItems: 'center' }}>
                                <ChartP3 dataLiterasi={dataReportSlb.kualitasPembelajaran.value} className={'pnl-slb1'} />
                            </div>
                        </div>
                    </EnsaCard>
                    <EnsaCard title="B. Iklim Keamanan Sekolah">
                        <div className="flex-pnl-between">
                            <div style={{ width: '25%' }}>
                                <GaugeDoughnut
                                    className="chart-gauge2"
                                    id="gaugeNeedle"
                                    skor={dataReportSlb.iklimKeamananSekolah.skor}
                                    valueChart={[dataReportSlb.iklimKeamananSekolah.skor, 3 - dataReportSlb.iklimKeamananSekolah.skor]}
                                    chartColor={[dataReportSlb.iklimKeamananSekolah.color]}
                                >
                                    <div className="point-label">{dataReportSlb.iklimKeamananSekolah.key}</div>
                                </GaugeDoughnut>
                            </div>
                            <div style={{ width: '75%', display: 'flex', alignItems: 'center' }}>
                                <ChartP3 dataLiterasi={dataReportSlb.iklimKeamananSekolah.value} className={'pnl-slb2'} />
                            </div>
                        </div>
                    </EnsaCard>
                    <EnsaCard title="C. Iklim Kebinekaan">
                        <div className="flex-pnl-between">
                            <div style={{ width: '25%' }}>
                                <GaugeDoughnut
                                    className="chart-gauge2"
                                    id="gaugeNeedle"
                                    skor={dataReportSlb.iklimKebinekaan.skor}
                                    valueChart={[dataReportSlb.iklimKebinekaan.skor, 3 - dataReportSlb.iklimKebinekaan.skor]}
                                    chartColor={[dataReportSlb.iklimKebinekaan.color]}
                                >
                                    <div className="point-label">{dataReportSlb.iklimKebinekaan.key}</div>
                                </GaugeDoughnut>
                            </div>
                            <div style={{ width: '75%', display: 'flex', alignItems: 'center' }}>
                                <ChartP3 dataLiterasi={dataReportSlb.iklimKebinekaan.value} className={'pnl-slb3'} />
                            </div>
                        </div>
                    </EnsaCard>
                </div>
                {/* page 18 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Raport Pendidikan Sekolah'} page={24} />
                    <div className="cardLine">
                        <div className="flex-pnl-between" style={{ gap: '20px' }}>
                            <EnsaCard2 title="C. Progres Survei Lingkungan Belajar" width={100} style={{ pageBreakAfter: 'always' }}>
                                <ChartLineProgresLiterasi dataProgres={dataReportSlb.progres.listData} ranges={dataReportSlb.progres.rangeTahun} height={300} />
                                <div style={{ display: 'flex', flexWrap: 'wrap', rowGap: '10px', columnGap: '10px' }}>
                                    {dataReportSlb.progres.listData.map((item, i) => (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }} key={i}>
                                            <div style={{ width: '20px', height: '10px', borderRadius: '10px', backgroundColor: item.color }}></div>
                                            <div className="label-profile-name">{item.kategori}</div>
                                        </div>
                                    ))}
                                </div>
                            </EnsaCard2>
                        </div>
                    </div>

                </div>
                {/* page 19 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Raport Pendidikan Sekolah'} page={25} />
                    <div className="point-title">D. Komparai Survei Lingkungan Belajar</div>
                    <EnsaCard title="Kualitas Pembelajaran">
                        <div className="pnl-packChart">
                            <PackedChart id={'packedChart-pembelajaran'} dataset={dataReportSlb.compareSekolah.pembelajaran.value} showLabel={true} size={35} fontSize={18} reqHeight={1000}></PackedChart>
                        </div>
                    </EnsaCard>
                </div>
                {/* page 20 */}
                <div className="report-page">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Raport Pendidikan Sekolah'} page={26} />
                    <EnsaCard title="Iklim Keamanan Sekolah">
                        <div className="pnl-packChart">
                            <PackedChart id={'packedChart-keamanan'} dataset={dataReportSlb.compareSekolah.keamananSekolah.value} showLabel={true} size={35} fontSize={18} reqHeight={1000}></PackedChart>
                        </div>
                    </EnsaCard>
                </div>
                {/* page 21 */}
                <div className="report-page-end">
                    <ReportHeader title={'EDUPRIME FOR NATIONAL STUDENT ASSESSMENT'} subtitle={'Raport Pendidikan Sekolah'} page={27} />
                    <EnsaCard title="Iklim Kebhinekaan">
                        <div className="pnl-packChart">
                            <PackedChart id={'packedChart-bhineka'} dataset={dataReportSlb.compareSekolah.bhineka.value} showLabel={true} size={35} fontSize={18} reqHeight={1000}></PackedChart>
                        </div>
                    </EnsaCard>
                </div>


                {/* End :: Page Two */}
                <div className="fixedButton">
                    <button className="buttonPrint" onClick={() => window.print()}>
                        <img
                            src="/assets/image/print.png"
                            width={22}
                            style={{ marginRight: 5 }}
                            alt=""
                        />
                        Print Report
                    </button>
                </div>
            </div>
        );
    }
}
export default ReportSiswa;
